//alert("hello from adam");//# sourceMappingURL=main.js.map

import '../scss/main.scss';

// Rest of js here:
import {page_loader} from "./modules/page-loader.js";
import {mobile_nav} from './modules/mobile-nav.js';
import {chrome} from './modules/chrome.js';
import {textSplit} from './modules/text-split.js';
import {lazyLoading} from './modules/lazy-loading.js';

document.addEventListener('DOMContentLoaded', () => {
    mobile_nav();
    chrome();
    textSplit();
    lazyLoading();
});
